import { FirebasePuntoTourModel } from "./puntoTour.model";
import { undefinedToFalse, undefinedToNull } from '../utilities';


export class FirebaseTourModel {

    name: string;
    id: string;
    uid: string;
    city: string;
    continent: string;
    country: string;
    description: string;
    imageUrl: string;
    imageSanitizer;
    fileLocation: string;
    isPublished: boolean;
    puntosTour: FirebasePuntoTourModel[];

    constructor() {
        this.name = '';
        this.id = '';
        this.uid = '';
        this.city = '';
        this.continent = '';
        this.country = '';
        this.description = '';
        this.imageUrl = null;
        this.fileLocation = '';
        this.isPublished = false;
        this.puntosTour = [];
    }

    toObject() {
        return Object.assign({}, this);
    }

    /**
     * @description Preparar para convertir a objeto generico para subir a la BBDD
     * @returns {any} Objeto genérico del tour
     */
    prepareTourObject() {
        var puntosTourObject = []
        this.puntosTour.forEach(puntoTour => {
            puntosTourObject.push(puntoTour.preparePTObject())
        })
        var tourObject = this.toObject();
        //Si el objeto genérico tour tiene el atributo imageSanitizer, lo borramos
        if (Object.keys(tourObject).includes("imageSanitizer")) {
            delete tourObject.imageSanitizer;
        }
        tourObject.puntosTour = puntosTourObject;

        return tourObject;
    }


    /**
     * @description Para convertir el objeto generico a modelo cada vez que recupere de la BBDD
     * @param {any} tourData - Objeto genérico del tour
     * @returns {FirebaseTourModel} Modelo de datos Angular
     */
    static objectToModel(tourData) {
        var tour = new FirebaseTourModel();
        tour.uid = undefinedToNull(tourData.uid);
        tour.name = undefinedToNull(tourData.name);
        tour.description = undefinedToNull(tourData.description);
        tour.continent = undefinedToNull(tourData.continent);
        tour.country = undefinedToNull(tourData.country);
        tour.city = undefinedToNull(tourData.city);
        tour.id = undefinedToNull(tourData.id);
        tour.imageUrl = undefinedToNull(tourData.imageUrl);
        tour.fileLocation = undefinedToNull(tourData.fileLocation);
        tour.isPublished = undefinedToFalse(tourData.isPublished);
        tourData.puntosTour.forEach(puntoTour => {
            tour.puntosTour.push(FirebasePuntoTourModel.objectPTtoModel(puntoTour))
        })
        return tour;

    }

}